import { h } from "preact";
import { useEffect, useState } from "preact/hooks";
import OverlayDialog from "../OverlayDialog";
import StepData from "./StepData";

import styles from "./MultiStepDialog.module.css";

interface Props {
    steps: StepData[];
    currentDisplayedStepIndex?: number;
    loading?: boolean;
    onClose: () => void;
}

export function MultiStepDialog({
    steps,
    currentDisplayedStepIndex,
    loading = false,
    onClose
}: Props) {
    const [currentStepIndex, setCurrentStepIndex] = useState(currentDisplayedStepIndex || 0);
    useEffect(() => {
        document.addEventListener("keydown", handleKeyDown, true);

        return () => {
            document.removeEventListener("keydown", handleKeyDown, true);
        };
    });

    async function onNextButtonClick() {
        await steps[currentStepIndex].nextStepButtonCallback?.();
        if (currentStepIndex < steps.length - 1) {
            setCurrentStepIndex(currentStepIndex + 1);
        } else {
            onClose();
        }
    }

    function onPreviousButtonClick() {
        if (currentStepIndex > 0) {
            setCurrentStepIndex(currentStepIndex - 1);
        } else {
            onClose();
        }
    }

    function handleKeyDown(event: KeyboardEvent) {
        if (event.keyCode === Zeplin.KEY_CODE.ENTER) {
            event.preventDefault();
            onNextButtonClick();
        }
    }

    return (
        <OverlayDialog
            positiveButtonText={steps[currentStepIndex].nextStepButtonText}
            onPositiveButtonClick={onNextButtonClick}
            hideNegativeButton={!steps[currentStepIndex].previousStepButtonText}
            negativeButtonText={steps[currentStepIndex].previousStepButtonText}
            onNegativeButtonClick={onPreviousButtonClick}
            onClose={onClose}
            width={540}
            loading={loading}
            footerClass={styles.footer}>
            {steps[currentStepIndex].element}
        </OverlayDialog>
    );
}

export default MultiStepDialog;
